import type { IncidentPriority } from '../types/incident.types'
import {
  PRIORITY_DOT_CLASS,
  PRIORITY_LABELS,
  PRIORITY_TEXT_CLASS,
} from '../constants/incidentMaps'

interface PriorityBadgeProps {
  priority: IncidentPriority
}

export function PriorityBadge({ priority }: PriorityBadgeProps): JSX.Element {
  return (
    <span className="inline-flex items-center gap-1.5 text-xs font-medium">
      <span
        data-testid="priority-dot"
        className={`h-1.5 w-1.5 rounded-full ${PRIORITY_DOT_CLASS[priority]}`}
      />
      <span className={PRIORITY_TEXT_CLASS[priority]}>{PRIORITY_LABELS[priority]}</span>
    </span>
  )
}
